import { useQuery } from "@tanstack/react-query";
import { getActiveListing } from "../api";
import { ActiveListingDto } from "../dtos";

export const useGetActiveListing = ({
  params,
}: {
  params: ActiveListingDto;
}) => {
  const query = useQuery({
    queryKey: ["listings", params],
    queryFn: () => getActiveListing(params),
    enabled: !!params,
  });

  return { ...query, data: query.data?.data };
};
